import axios from 'axios';
import { PAYMENT_METHOD } from './utilityFunctions';

/** POST: CREDIT CARDS */
const handleAddCreditCard = async (_csrf, token) => {
  const { data: response } = await axios.post(
    '/api/payment/methods',
    { paymentMethodType: PAYMENT_METHOD.CREDIT_CARD, token },
    {
      headers: {
        'Accept-Version': '1.0.0',
        'X-Gamification-API': 'License',
        'X-CSRF-Token': _csrf,
        _csrf,
      },
    },
  );

  return response.data;
};

/** DELETE: CREDIT CARDS */
const handleRemoveCreditCard = async (_csrf, paymentMethodId) => {
  await axios.delete('/api/payment/methods', {
    data: { paymentMethodId },
    headers: {
      'Accept-Version': '1.0.0',
      'X-Gamification-API': 'License',
      'X-CSRF-Token': _csrf,
      _csrf,
    },
  });
};

/** GET: CREDIT CARDS LIST */
const getCreditCardList = async _csrf => {
  const { data: response } = await axios.get('/api/payment/methods/list', {
    headers: {
      'Accept-Version': '1.0.0',
      'X-Gamification-API': 'License',
      'X-CSRF-Token': _csrf,
      _csrf,
    },
  });
  return response.data;
};

/**
 * Get Client Secret by setting an intent for future payments
 *
 * @param {string} _csrf - CSRF token for the request
 * @param {string} paymentMethodType - Type of the payment method
 * @returns {Promise<string>} - Response data containing the client secret
 */
const getStripeClientSecret = async (_csrf, paymentMethodType) => {
  const { data: response } = await axios.post(
    '/api/payment/methods/intent/future',
    { paymentMethodType },
    {
      headers: {
        'Accept-Version': '1.0.0',
        'X-Gamification-API': 'License',
        'X-CSRF-Token': _csrf,
        _csrf,
      },
    },
  );
  const { client_secret: clientSecret } = response.data;
  return clientSecret;
};

const attachPaymentMethod = async (_csrf, paymentMethodId) => {
  const { data: response } = await axios.put(
    '/api/payment/methods/attach',
    { paymentMethodId },
    {
      headers: {
        'Accept-Version': '1.0.0',
        'X-Gamification-API': 'License',
        'X-CSRF-Token': _csrf,
        _csrf,
      },
    },
  );
  return response.data;
};

export {
  handleAddCreditCard,
  handleRemoveCreditCard,
  getCreditCardList,
  getStripeClientSecret,
  attachPaymentMethod,
};
